import { Spinner } from "@repo/ui4/components/Spinner";

export const LoadingBox = () => {
  return (
    <div className="flex min-h-32 items-center justify-center text-muted-foreground">
      <Spinner aria-label="読み込み中" />
    </div>
  );
};
